module.exports = __webpack_public_path__ + "img/upload-cloud-2-line.4c3dffed.svg";